export default {
  settings: {
    mimeType: 'application/json',
    corsEnabled: false
  },
  environments: {
    staging: 'https://develop-accounts.idtysandbox.imdserve.com',
    preproduction: 'https://release-accounts.idty.imdserve.com',
    production: 'https://production-accounts.idty.imdserve.com'
  },
  endpoints: {
    claims: {
      endpoint: '/webuseraccountapi/settings'
    },
    account: {
      endpoint: '/webuseraccountapi'
    }
  }
};